import React from 'react'
import styled from 'styled-components'
import mail from "../assets/mail.png"
import linkedin from "../assets/linkedin.png"
import github from "../assets/github.png"
import connect from "../assets/connect.jpg"
import { hover } from '@testing-library/user-event/dist/hover'

function Contact() {
  return (
    <ContCont id='contact'>
      <GetT>
        <img src={mail} />
        <div>
          <h1>Get in Touch!</h1>
        </div>
        <div>
          <h2>Whether you have an idea for a project or just want to chat, feel free to shoot me an email!</h2>
        </div>
        <MailCont>
          <a href='mailto:uruj.work@gmail.com' target='_blank'>Say Hello</a>
        </MailCont>
      </GetT>
      <Social>
        <div>
          <GitCont>
            <a href='https://github.com/Ma-urj' target='_blank'>
              <img src={github} />
            </a>
          </GitCont>
          <LinkedCont>
            <a href='https://www.linkedin.com/in/maurj/' target='_blank'>
              <img src={linkedin} />
            </a>
          </LinkedCont>
        </div>
      </Social>
    </ContCont>
  )
}

export default Contact

const GitCont = styled.div`
  &:hover{
    background: #6e5494;
  }
`

const LinkedCont = styled.div`
  &:hover{
    background: #004182;
  }
`

const ContCont = styled.div`
  padding-top: 15vh;
  background: linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)),url(${connect});
  background-opacity: 50%;
  color: black;
  transition: all 0.1s ease-in;
`

const MailCont = styled.button`
  text-decoration: none;
  background: none;
  padding: 2vh 5vh;
  border: 3px solid black;
  margin-bottom: 5vh;
  a{
    font-size: 1.5em;
  }
  &:hover{
    background: #222222;
    cursor: pointer;
    a{
      color: white;
    }
  }
`

const GetT = styled.div`
  padding: 0 10vw;
  div{
    padding-bottom: 2vh;
  }
  a{
    text-decoration: none;
    color: black;
  }
  img{
    height: 15vh;
  }
`

const Social = styled.div`
  background: #222222;
  color: white;
  padding: 5vh 0;
  div{
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      background: #333333;
      padding: 1vh;
      cursor: pointer;
      margin-right: 0.8vh;
    }
  }
  img{
    height: 5vh;
  }
`